import { render, staticRenderFns } from "./TheKPIList.vue?vue&type=template&id=782f42bf&scoped=true"
import script from "./TheKPIList.vue?vue&type=script&lang=js"
export * from "./TheKPIList.vue?vue&type=script&lang=js"
import style0 from "./TheKPIList.vue?vue&type=style&index=0&id=782f42bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "782f42bf",
  null
  
)

export default component.exports
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QIcon,QInnerLoading,QSpinner});
